import * as Colors from 'material-ui/styles/colors';

export default {
  sectionTitle: {
    textAlign: 'center',
    color: Colors.grey500,
    userSelect: 'none',
    fontFamily: 'Roboto, sans-serif',
    fontSize: '14px',
    fontWeight: 'medium',
    textTransform: 'uppercase',
    paddingBottom: '5px'
  },
  divider: {
    position: 'absolute',
    left: 0,
    right: 0
  }
};
